import $ from 'jquery';
// import mpro from './mpro.init';

import {
	applyComponentClickRestrictions,
	getOptionsFromDataset,
} from '../../util/dom.js';

import MpDrawer from '../../modules/components/drawer.js';


// Export helpers to mpro namespace
mpro.showDrawer = MpDrawer.show.bind(MpDrawer);
mpro.getActiveDrawer = MpDrawer.getActive.bind(MpDrawer);
mpro.getAllDrawers = MpDrawer.getAll.bind(MpDrawer);
mpro.closeDrawer = MpDrawer.close.bind(MpDrawer);
mpro.closeAllDrawers = MpDrawer.closeAll.bind(MpDrawer);

// Add init function that is executed only on first dom-ready (it should contain only document/body delegate handlers)
mpro.addInitDelegate(($) => {

	const $B = mpro.get$B();

	// Drawer Clicks
	$B.on('click.mp-drawer', '[data-drawer]', function(e) {

		/** @type {HTMLElement} */
		const that = this;
		const options = getOptionsFromDataset(that, 'drawer', true);

		// Standard component click restrictions
		if (applyComponentClickRestrictions('drawer', options, e) === false) {
			return;
		}

		// Close all other modals
		// MpDrawer.closeAll({ closable: true });

		// Close toasts and similar overlays
		mpro.closeSimpleOverlays();

		// Display the instance
		MpDrawer.show({
			relatedTarget: that,
			url: that.getAttribute('href'),
			skipDataset: true,
			...options,
		});
	});
});

export default mpro;
